import React from "react";
import { Modal, Button } from "@hid-galaxy-ui/galaxy-react";
import "./Modals.scss";

interface HLScenariosModalProps {
  scenarios: string;
  onClose: () => void;
}

const HLScenariosModal: React.FC<HLScenariosModalProps> = ({
  scenarios,
  onClose,
}) => {
  return (
    <Modal
      headerText="H/L Scenarios"
      width={800}
      onClose={onClose}
      className="hl-scenarios-modal"
    >
      <div className="modal-content">
        <p className="description-text">{scenarios}</p>
        <div className="modal-footer">
          <Button
            variant="primary"
            label="OK"
            normalCase={true}
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};

export default HLScenariosModal;

